import { Component, Input } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "confirm-dialog",
    templateUrl: "../../../html/incs/confirmation-dialog.html"
})
export class ConfirmationDialog {
  public confirmMessage:string|null = null;
    public confirmTitle: string = "Confirm";
    public cancelButton: string = "Cancel";
    public confirmButton: string = "Confirm";

  constructor(public dialogRef: MatDialogRef<ConfirmationDialog>) {}

}